import loadable from '@loadable/component';
import loadableModule from '../../components/loadable-module';

const ValuePropsModule = loadableModule({
    LoadableComponent: loadable(() =>
        import(
            /* webpackChunkName: "value-props" */
            './'
        )
    ),
    componentName: 'ValueProps',
});

export default ValuePropsModule;
